/**
 * A notice stores the page it opens as a route of the full app (D-143, D-148). The Team tab (a person who only has Team roles)
 * has fewer pages: the same notice lands on the closest one.
 */
export function routeFor(page: string, teamShell: boolean): string {
  if (/^\/review\/[\w-]+(\/[\w-]+)?$/.test(page)) return page; // the review of a Team opens in both shells
  if (!teamShell) return page;
  const campaign = /^\/campaigns\/([\w-]+)$/.exec(page);
  if (campaign) return `/review/${campaign[1]}`;
  if (page === "/removals" || page === "/exceptions") return "/pending";
  return "/";
}
